import { CPS_ACTIONS_ALLOWED_FOR_DOCUMENT, CpsFacetValue, PERMISSIONS_FIELD } from '@cs-cms/types';
import { CpsGridDocument } from '../cpsGridTypes';

export const computeActionsFacets = (
  gridData: CpsGridDocument[],
  translate: (key: string) => string
): CpsFacetValue[] => {
  if (gridData.length === 0) {
    return [];
  }

  const actionValueToName: Record<number, string> = {};
  for (const key in CPS_ACTIONS_ALLOWED_FOR_DOCUMENT) {
    const value = CPS_ACTIONS_ALLOWED_FOR_DOCUMENT[key as keyof typeof CPS_ACTIONS_ALLOWED_FOR_DOCUMENT];
    actionValueToName[value] = key;
  }

  const actionCounts: Record<string, number> = {};

  gridData.forEach(item => {
    const actions = item[PERMISSIONS_FIELD];
    if (!actions || !actions.length) {
      return;
    }

    const hasNonZeroActions = actions.some(value => value !== 0);

    actions.forEach(actionValue => {
      if (actionValue === 0 && hasNonZeroActions) {
        return;
      }

      const actionName = actionValueToName[actionValue];
      if (actionName) {
        actionCounts[actionName] = (actionCounts[actionName] ?? 0) + 1;
      }
    });
  });

  return Object.entries(actionCounts)
    .filter(([, count]) => count > 0)
    .map(([action, count]) => ({
      value: translate(`grid.filter${action.charAt(0) + action.slice(1).toLowerCase()}`),
      count
    }));
};
